import React from 'react';

/**
 * Legenda das bordas por trabalho no overlay multi-trabalho.
 * A cor da borda identifica o trabalho; a escala de valor permanece no MapLegend.
 * Fonte branca na tela; preta na impressão (ver MAP_PRINT_PAGE_STYLE).
 */
const MapWorkBorderLegend = ({ items }) => {
  if (!Array.isArray(items) || items.length < 2) {
    return null;
  }

  return (
    <div
      className="map-legend-print map-work-border-legend"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        paddingTop: '12px',
        paddingBottom: '4px',
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact',
      }}
    >
      <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#fff' }}>
        Bordas por trabalho:
      </span>
      {items.map((item) => (
        <div
          key={item.id ?? item.label}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          <span
            style={{
              width: 28,
              height: 10,
              borderRadius: 2,
              backgroundColor: 'transparent',
              border: `3px solid ${item.color}`,
              boxSizing: 'border-box',
              flexShrink: 0,
              WebkitPrintColorAdjust: 'exact',
              printColorAdjust: 'exact',
            }}
          />
          <span style={{ fontSize: '0.9rem', color: '#fff' }}>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default MapWorkBorderLegend;
